import React from 'react';

// Reusable FormSection component
interface FormSectionProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  description,
  children,
}) => {
  return (
    <>
      <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
        <div className="space-y-1">
          <h2 className="text-base/7 font-semibold text-zinc-950 sm:text-sm/6 dark:text-white">
            {title}
          </h2>
          <p className="text-base/6 text-zinc-500 sm:text-sm/6 dark:text-zinc-400">
            {description}
          </p>
        </div>
        {children}
      </section>
      <hr
        role="presentation"
        className="my-10 w-full border-t border-zinc-950/5 dark:border-white/5"
      />
    </>
  );
};
